import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';

const useShowNoFunModeMessage = () => {
  const { game, isFunMode } = useGameContext();
  const isLoggedIn = useIsLoggedIn();
  return (!isLoggedIn || isFunMode) && !game?.hasFunMode;
};

export default useShowNoFunModeMessage;
